module.exports = __webpack_public_path__ + "static/banner-two-shape8-f8b8ca5fdcb540c5fc570ab8812f0780.png";